/**
 * Recursively deep-merges plain objects (JSON-safe values only).
 * Purpose-built for locale files — no arrays, Dates, or special types.
 *
 * @param  {...Object} sources
 * @returns {Object}
 */
export function deepMerge(...sources) {
  return sources.reduce((result, source) => {
    if (!source || typeof source !== 'object') return result;
    for (const [key, value] of Object.entries(source)) {
      result[key] =
                value !== null && typeof value === 'object' && !Array.isArray(value)
                  ? deepMerge(result[key] ?? {}, value)
                  : value;
    }
    return result;
  }, {});
}
